import { render, staticRenderFns } from "./PrgParamManage.vue?vue&type=template&id=da2a7a1e&scoped=true&"
import script from "./PrgParamManage.vue?vue&type=script&lang=js&"
export * from "./PrgParamManage.vue?vue&type=script&lang=js&"
import style0 from "./PrgParamManage.vue?vue&type=style&index=0&id=da2a7a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2a7a1e",
  null
  
)

export default component.exports